import { type ConfigurationParameterValue, type ServiceParameter } from "../api";
import { Entity } from "../base";
// create view model
export class ConfigurationParameterValueEntity<VALUE = unknown>
    extends Entity<ConfigurationParameterValue<VALUE>>
    implements ConfigurationParameterValue<VALUE>
{
    readonly id: ServiceParameter.Id;
    readonly value: VALUE;
    readonly name?: string;
    readonly displayValue?: string;

    constructor(props: ConfigurationParameterValue<VALUE>) {
        super(props.id);
        this.value = props.value;
        this.id = props.id;
        this.name = props.name;
        this.displayValue = props.displayValue;
    }

    getValue(): VALUE {
        return this.value;
    }

    getName(): string | undefined {
        return this.name;
    }

    getDisplayValue(): string | undefined {
        return this.displayValue;
    }

    static create<VALUE = unknown>(
        value: ConfigurationParameterValue<VALUE>
    ): ConfigurationParameterValueEntity<VALUE> {
        return new ConfigurationParameterValueEntity(value);
    }
}
